import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as classes from './classes.module.scss';

const renderTitle = (title) => {
  if (typeof title === 'string') {
    return (
      <h3>{ title }</h3>
    );
  }
  return title;
};

const Header = ({
  title, onClose, Icon, className, children
}) => (
  <>
    <div className={ classnames(classes.header, className) }>
      { Icon ? <Icon fill="#000" className={ classes.icon } /> : null }
      { renderTitle(title) }
      <div className={ classes.right }>
        <button className={ classes.close } onClick={ onClose } type="button">
          &times;
        </button>
      </div>
    </div>
    { children }
  </>
);

Header.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  Icon: PropTypes.func,
  className: PropTypes.string
};

const PanelLayout = ({
  title, onClose, children, icon, headerClass, headerChildren
}) => (
  <div className={ classes.panelLayout }>
    <Header title={ title } onClose={ onClose } Icon={ icon } className={ headerClass }>
      { headerChildren }
    </Header>
    <div className={ classes.body }>
      { children }
    </div>
  </div>
);

PanelLayout.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  headerChildren: PropTypes.node,
  icon: PropTypes.func,
  headerClass: PropTypes.string
};

export default PanelLayout;
